import React, { useState } from 'react';
import { OidcIdentityContext } from '@rsmus/react-auth';
import { format } from 'date-fns-tz';

const WelcomeBanner = () => {
        const auth = React.useContext(OidcIdentityContext);
        const [name] = useState<any>(auth?.user?.profile?.FirstName)
        const currentDate = new Date();
        const formattedDate = format(currentDate, "MMM d, yyyy");
        const marginTopStyle = {marginTop: '2px'};

        return (
            <>
                <h3>Welcome, {name}</h3>
                <span style={marginTopStyle}>
                    Today: {formattedDate}
                </span>
            </>
        )
    }

export default React.memo(WelcomeBanner);